import { render, staticRenderFns } from "./TheAdminLink.vue?vue&type=template&id=0e3cc6b5&scoped=true&lang=pug&"
import script from "./TheAdminLink.vue?vue&type=script&lang=js&"
export * from "./TheAdminLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3cc6b5",
  null
  
)

export default component.exports